import React, { useState, useEffect, useRef } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderIcon,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../../_metronic/_partials/controls';
import { Modal } from 'react-bootstrap';
import Activities from '../../../../../components/Activities';
import ChangedInfo from '../../../../../components/ChangedInfo';
import * as actions from '../../../_redux/boxes/boxesActions';
import BoxViewForm from './BoxViewForm';

export function BoxViewDialog({
  history,
  match: {
    params: { id },
  },
}) {
  const intl = useIntl();
  const [tab, setTab] = useState('box');
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [dialogError, setDialogError] = useState('');
  const titleText = intl.formatMessage({ id: 'BOX.TITLE.DETAIL' });

  const { actionsLoading, boxForView, error, msg } = useSelector(
    (state) => ({
      actionsLoading: state.boxes.actionsLoading,
      boxForView: state.boxes.boxForView,
      error: state.boxes.error,
      msg: state.boxes.msg,
    }),
    shallowEqual
  );

  useEffect(() => {
    console.log('Id1', id);
    dispatch(actions.fetchBox(id));
  }, [id, dispatch]);

  useEffect(() => {
    console.log('BoxForView', boxForView);
    let _title = intl.formatMessage({ id: 'BOX.TITLE.DETAIL' });
    if (boxForView && id) {
      _title = `${titleText}: #${boxForView.id}`;
    }

    setTitle(_title);
  }, [boxForView, id]);

  useEffect(() => {
    setDialogError(error);
  }, [error]);

  const onHide = () => {
    history.push(`/boxes`);
  };

  const saveBox = (values) => {
    if (!loading) {
      setLoading(true);
      console.log('saveBox', values);
      dispatch(actions.updateBox(values));
      setLoading(false);
    }
  };

  const btnRefSave = useRef();
  const saveBoxClick = () => {
    //console.log('saveOrderClick');
    if (btnRefSave && btnRefSave.current) {
      btnRefSave.current.click();
    }
  };

  return (
    <>
      <Modal.Body className='overlay overlay-block cursor-default'>
        {actionsLoading && <ModalProgressBar />}
        {actionsLoading && (
          <div className='overlay-layer bg-transparent'>
            <div className='spinner spinner-lg spinner-success' />
          </div>
        )}
        <Card>
          <CardHeader title={`${title}`}>
            <CardHeaderToolbar>
              <button
                type='button'
                onClick={onHide}
                className='btn btn-light btn-elevate'
              >
                <FormattedMessage id='GENERAL.BUTTON.CANCEL' />
              </button>
              <> </>
              {tab === 'box' && (
                <button
                  type='submit'
                  className='btn btn-primary ml-2'
                  onClick={saveBoxClick}
                  disabled={boxForView && boxForView.status === 5}
                >
                  <FormattedMessage id='GENERAL.BUTTON.SAVE' />
                  {loading && (
                    <span
                      id='boxSaveLoading2'
                      className='ml-3 spinner spinner-white '
                    ></span>
                  )}
                </button>
              )}
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <ul className='nav nav-tabs nav-tabs-line ' role='tablist'>
              <li className='nav-item' onClick={() => setTab('box')}>
                <a
                  className={`nav-link ${tab === 'box' && 'active'}`}
                  data-toggle='tab'
                  role='tab'
                  aria-selected={(tab === 'box').toString()}
                >
                  Бүртгэл
                </a>
              </li>
              <li className='nav-item' onClick={() => setTab('activity')}>
                <a
                  className={`nav-link ${tab === 'activity' && 'active'}`}
                  data-toggle='tab'
                  role='button'
                  aria-selected={(tab === 'activity').toString()}
                >
                  Өөрчлөлтийн түүх
                </a>
              </li>
            </ul>
            <div className='mt-5'>
              {tab === 'box' && (
                <BoxViewForm
                  actionsLoading={actionsLoading}
                  boxForView={boxForView}
                  btnRefSave={btnRefSave}
                  saveBox={saveBox}
                  onHide={onHide}
                  dialogError={dialogError}
                  dialogMsg={msg}
                />
              )}
              {tab === 'activity' && id && (
                <Activities
                  orderCode={boxForView.orderCode}
                  trackingId={boxForView.trackingId}
                />
              )}
            </div>
          </CardBody>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        {boxForView && (
          <ChangedInfo
            value={{
              createdByName: boxForView.createdByName,
              createdAt: boxForView.createdAt,
              updatedByName: boxForView.createdByName,
              updatedAt: boxForView.updatedAt,
            }}
          />
        )}
      </Modal.Footer>
    </>
  );
}
